import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useGetConfiguration } from '../../../api/hooks'
import vehicleCodeStatusSelector from '../../../redux/selectors/vehicleCodeStatusSelector'
import { resetConfiguration } from '../../../redux/actions/app/configuration.actions'
import { createNotification } from '../../../redux/actions/app/notification.actions'
import { resetVehicleCodeStatus } from '../../../redux/actions/app/vehicleCode.actions'

export const useCurrentConfigurationFromVehicleCode = () => {
    const dispatch = useDispatch()
    const vehicleCodeState = useSelector(vehicleCodeStatusSelector)
    const code = vehicleCodeState?.code
    const [hasErrored, setHasErrored] = useState(false)

    const shouldFetch = code && vehicleCodeState?.status === 'RESCUE' && !hasErrored

    const { data, isLoading, error } = useGetConfiguration(shouldFetch ? code : null)

    useEffect(() => {
        if (error && !hasErrored) {
            setHasErrored(true)
            dispatch(resetConfiguration(undefined, undefined))
            dispatch(resetVehicleCodeStatus())
            dispatch(createNotification({
                type: 'error',
                message: 'error.general',
            }))
        }
    }, [error, hasErrored, dispatch])

    return { data, isLoading, error }
}
